import moment from "moment";

const esc = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const text = (value) =>
  value === null || value === undefined || value === "" ? "—" : value;

const formatDateTime = (value) => {
  if (!value) return "—";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("DD-MMM-YYYY HH:mm") : String(value);
};

const cell = (value) =>
  `<td style="padding:6px 8px;border:1px solid #d9d9d9;">${esc(text(value))}</td>`;

export const buildMultipleVehicleHtml = (record) => {
  const vehicles = record?.assigned_vehicles || [];
  const invoice = record?.invoice_info;
  const salesContract =
    record?.sales_contract_info?.reference_no ||
    invoice?.sales_contract_number;
  const applicant = record?.created_by?.name || record?.creator?.name || "";

  const vehicleRows = vehicles.length
    ? vehicles
        .map(
          (item) => `<tr>
            ${cell(item?.vehicle_number)}
            ${cell(item?.vehicle_size)}
            ${cell(item?.vehicle_type)}
            ${cell(item?.loading_qty)}
            ${cell(item?.loading_cbm)}
            ${cell(item?.driver_name)}
            ${cell(item?.driver_cell_number)}
            ${cell(item?.challan_info?.challan_no)}
          </tr>`,
        )
        .join("")
    : `<tr><td colspan="8" style="padding:6px 8px;border:1px solid #d9d9d9;">No vehicles</td></tr>`;

  return `
    <div style="font-family:Arial,sans-serif;color:#111;padding:16px;">
      <h2 style="text-align:center;margin:0 0 12px;">Import Shipment for Multiple Vehicle</h2>
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <tr><td style="width:22%;padding:6px 8px;border:1px solid #d9d9d9;font-weight:600;">Transporter</td>${cell(vehicles[0]?.transporter)}</tr>
        <tr><td style="padding:6px 8px;border:1px solid #d9d9d9;font-weight:600;">Importer</td>${cell(vehicles[0]?.importer_name)}</tr>
        <tr><td style="padding:6px 8px;border:1px solid #d9d9d9;font-weight:600;">Type of Shipment</td>${cell(record?.type_of_shipment)}</tr>
        <tr><td style="padding:6px 8px;border:1px solid #d9d9d9;font-weight:600;">LC Number</td>${cell(record?.b2b_lc_info?.b2b_lc_number)}</tr>
        <tr><td style="padding:6px 8px;border:1px solid #d9d9d9;font-weight:600;">Sales Contract</td>${cell(salesContract)}</tr>
        <tr><td style="padding:6px 8px;border:1px solid #d9d9d9;font-weight:600;">Invoice Number</td>${cell(invoice?.invoice_number)}</tr>
        <tr><td style="padding:6px 8px;border:1px solid #d9d9d9;font-weight:600;">Loading Qty (Total)</td>${cell(record?.loading_qty)}</tr>
        <tr><td style="padding:6px 8px;border:1px solid #d9d9d9;font-weight:600;">Loading CBM (Total)</td>${cell(record?.loading_cbm)}</tr>
      </table>
      <h3 style="margin:18px 0 8px;font-size:14px;">Vehicle Details</h3>
      <table style="width:100%;border-collapse:collapse;font-size:12px;">
        <thead>
          <tr>
            ${["Vehicle Number", "Vehicle Size", "Vehicle Type", "Loading Qty", "Loading CBM", "Driver Name", "Driver Cell No.", "Challan No"]
              .map(
                (heading) =>
                  `<th style="padding:6px 8px;border:1px solid #d9d9d9;background:#f5f5f5;text-align:left;">${heading}</th>`,
              )
              .join("")}
          </tr>
        </thead>
        <tbody>${vehicleRows}</tbody>
      </table>
      <table style="width:100%;margin-top:56px;font-size:12px;">
        <tr>
          <td style="width:33%;text-align:center;vertical-align:bottom;">
            <div style="min-height:36px;">${esc(applicant)}</div>
            <div style="border-top:1px solid #000;margin:0 28px;padding-top:6px;">Applicant</div>
          </td>
          <td style="width:33%;text-align:center;vertical-align:bottom;">
            <div style="min-height:36px;"></div>
            <div style="border-top:1px solid #000;margin:0 28px;padding-top:6px;">Checked by</div>
          </td>
          <td style="width:33%;text-align:center;vertical-align:bottom;">
            <div style="min-height:36px;"></div>
            <div style="border-top:1px solid #000;margin:0 28px;padding-top:6px;">Approved by</div>
          </td>
        </tr>
      </table>
    </div>
  `;
};

export const downloadMultipleVehicle = (record) => {
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8" /><title>Import Shipment for Multiple Vehicle</title></head><body>${buildMultipleVehicleHtml(
    record,
  )}</body></html>`;
  const blob = new Blob([html], { type: "application/vnd.ms-excel" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `import-multiple-vehicle-${record?.invoice_info?.invoice_number || record?.id || "shipment"}.xls`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

const ImportMultipleVehiclePrint = ({ record }) => (
  <div dangerouslySetInnerHTML={{ __html: buildMultipleVehicleHtml(record) }} />
);

export default ImportMultipleVehiclePrint;
